import { LoginConfigResponse } from '../types/login-config.types';

/**
 * Used when GET /u/rest/login/config is unavailable. Matches the Java endpoint
 * behaviour when AppsConfig is null (empty appsConfig object). App IDs are never
 * hardcoded in the frontend - they come from grid cfg at runtime via the endpoint.
 */
export const LOGIN_CONFIG_FALLBACK: LoginConfigResponse = {
  grid: 'unknown',
  appsConfig: {},
  appMessagesConfig: {},
};
